import React from 'react';
export function Hero() {
  return <section id="hero" className="min-h-screen flex items-center relative overflow-hidden pt-[70px] px-[5%]" data-id="element-90">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_70%_50%,rgba(26,79,219,0.15)_0%,transparent_60%),radial-gradient(ellipse_at_20%_80%,rgba(13,45,138,0.1)_0%,transparent_50%),linear-gradient(180deg,#0f1117_0%,#0d1220_100%)] z-0" data-id="element-91"></div>
      <div className="absolute inset-0 bg-[linear-gradient(rgba(37,99,235,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(37,99,235,0.05)_1px,transparent_1px)] bg-[size:60px_60px] z-0" data-id="element-92"></div>

      <div className="relative z-10 max-w-[700px] md:text-left text-center w-full" data-id="element-93">
        <div className="inline-flex items-center gap-[8px] bg-azul-neon/15 border border-azul-neon/40 rounded-full px-[18px] py-[8px] text-[13px] text-acento font-medium mb-[28px] tracking-[0.5px]" data-id="element-94">
          <i className="fas fa-map-marker-alt text-[11px]" data-id="element-95"></i>
          Centro de San Luis · Maipú 766
        </div>

        <h1 className="font-rajdhani text-[clamp(42px,6vw,78px)] font-bold leading-[1.05] mb-[20px] tracking-[-0.5px]" data-id="element-96">
          Mecánica de
          <br data-id="element-97" />
          <span className="text-gradient block" data-id="element-98">Alta Precisión</span>
        </h1>

        <p className="text-[clamp(16px,2vw,19px)] text-texto-gris leading-[1.7] mb-[40px] max-w-[560px] md:mx-0 mx-auto" data-id="element-99">
          Diagnóstico avanzado, reparación y potenciación para todos los
          vehículos. Más de 30 años de experiencia en San Luis.
        </p>

        <div className="flex gap-[16px] flex-wrap md:justify-start justify-center" data-id="element-100">
          <a href="https://wa.me/5492664261245" target="_blank" rel="noreferrer" className="inline-flex items-center gap-[10px] bg-gradient-primary text-blanco px-[32px] py-[16px] rounded-[10px] no-underline font-semibold text-[15px] tracking-[0.3px] border border-azul-neon/50 transition-all duration-300 shadow-[0_4px_25px_rgba(37,99,235,0.3)] hover:-translate-y-[2px] hover:shadow-[0_8px_35px_rgba(37,99,235,0.5)] hover:bg-gradient-hover" data-id="element-101">
            <i className="fab fa-whatsapp" data-id="element-102"></i>
            Pedir Turno
          </a>
          <a href="#servicios" className="inline-flex items-center gap-[10px] bg-transparent text-blanco px-[32px] py-[16px] rounded-[10px] no-underline font-medium text-[15px] border border-white/20 transition-all duration-300 hover:bg-white/5 hover:border-white/40" data-id="element-103">
            <i className="fas fa-tools" data-id="element-104"></i>
            Ver Servicios
          </a>
        </div>

        <div className="flex md:gap-[50px] gap-[30px] mt-[60px] pt-[40px] border-t border-white/10 md:justify-start justify-center flex-wrap" data-id="element-105">
          <div className="text-left md:text-left text-center" data-id="element-106">
            <div className="font-rajdhani text-[38px] font-bold text-blanco leading-none" data-id="element-107">
              +<span className="text-acento" data-id="element-108">30</span>
            </div>
            <div className="text-[12px] text-texto-gris uppercase tracking-[1px] mt-[4px]" data-id="element-109">
              Años de exp.
            </div>
          </div>
          <div className="text-left md:text-left text-center" data-id="element-110">
            <div className="font-rajdhani text-[38px] font-bold text-blanco leading-none" data-id="element-111">
              <span className="text-acento" data-id="element-112">Todas</span>
            </div>
            <div className="text-[12px] text-texto-gris uppercase tracking-[1px] mt-[4px]" data-id="element-113">
              Las marcas
            </div>
          </div>
          <div className="text-left md:text-left text-center" data-id="element-114">
            <div className="font-rajdhani text-[38px] font-bold text-blanco leading-none" data-id="element-115">
              <span className="text-acento" data-id="element-116">ECU</span>
            </div>
            <div className="text-[12px] text-texto-gris uppercase tracking-[1px] mt-[4px]" data-id="element-117">
              Stage / Tuning
            </div>
          </div>
        </div>
      </div>

      <div className="absolute right-[5%] top-1/2 -translate-y-1/2 w-[42%] z-10 hidden lg:block" data-id="element-118">
        <div className="absolute inset-[-2px] rounded-[18px] bg-gradient-to-br from-azul via-transparent to-azul-oscuro z-[-1] opacity-40" data-id="element-119"></div>
        <div className="relative rounded-[16px] overflow-hidden border border-azul-neon/30 shadow-[0_25px_80px_rgba(0,0,0,0.6),0_0_60px_rgba(37,99,235,0.15)] aspect-[9/16] max-h-[75vh] bg-gris-medio" data-id="element-120">
          <video autoPlay muted loop playsInline className="w-full h-full object-cover" data-id="element-121">
            <source src="https://cdn.magicpatterns.com/uploads/xqGQF5UXQnNYuoW2BpFUQc/VIDEO 1.MOV" type="video/mp4" data-id="element-122" />
          </video>
        </div>
      </div>

      <div className="absolute bottom-[30px] left-1/2 -translate-x-1/2 flex flex-col items-center gap-[8px] text-texto-gris text-[11px] uppercase tracking-[2px] animate-bounce-slow z-10" data-id="element-123">
        <i className="fas fa-chevron-down text-[18px]" data-id="element-124"></i>
        Scroll
      </div>
    </section>;
}